import React from 'react';
import { graphql, compose } from 'react-apollo';
import { withStyles } from '@material-ui/core/styles';
import $ from 'jquery';
import { Link } from 'react-router-dom';

import {
    SortingState, FilteringState, IntegratedFiltering, IntegratedSorting,
} from '@devexpress/dx-react-grid';
import {
    Grid,
    VirtualTable, TableHeaderRow, TableFilterRow, TableColumnResizing,
} from '@devexpress/dx-react-grid-material-ui';
import * as Icon from '@material-ui/icons';
import ComponentEx from 'components/ComponentEx';
import { Button } from '@material-ui/core';
import c from 'components/form/Components';
import { getTxt, toItalianDateString, toDecimalString, filterRowMessages, tableMessages, createGridResizerCols } from '../../global/appGlobal';
import LinkToCustomerById from '../../components/LinksToObjectById';
import LinearProgressEx from '../../components/LinearProgressEx';
import { getLabel, getDictionary, DictionaryTypes } from '../../global/dictionaryCache';
import { allRequestsQuery } from '../../modules/request/requestQeries';
import { Menu, MenuItem } from '@material-ui/core';
import CurrencyGridFormatter from 'components/CurrencyGridFormatter';
import { IconButton } from '@material-ui/core';

import * as Icons from '@material-ui/icons';
import RegularCard from '../../components/dashboard/RegularCard';
import * as queries from '../../modules/client/clientQueries';
import Customer_Payment_Edit from '../../modules/client/Client_Payment_Edit';
import File_Search from 'modules/file/File_Search';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Tooltip } from '@material-ui/core';


const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        margin: theme.spacing.unit * 3,
    },
    button: {
        marginRight: theme.spacing.unit,
    },

    tableHeader: {
        backgroundColor: theme.palette.background.paper,
    },
    menuItem: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& $text, & $icon': {
                color: theme.palette.common.white,
            },
        },
    },
    text: {},
    icon: {},
    totalsRow: {
        backgroundColor: theme.palette.grey['200'],
        fontWeight: 'bold',
    },
    formButtons: {
        float: 'right',
        margin: '15px',
    },
});

const toLowerCase = value => String(value).toLowerCase();

const filterByBroker = (cellValue, e, row) => {
    const name = toLowerCase(row.broker.display_name);
    return name.includes(toLowerCase(e.value));
};

const filterByCustomer = (cellValue, e, row) => {
    const name = toLowerCase(row.customer.display_name);
    return name.includes(toLowerCase(e.value));
};

const filterByPaymentDate = (cellValue, e, row) => {
    const dateStr = row.payment_date ? toItalianDateString(row.payment_date) : row.payment_date;
    return dateStr && dateStr.includes(e.value);
};

const tableColumnExtensions = [
    { columnName: 'payment_amount', align: 'right' },
];


class Client_Payments_Search extends ComponentEx {

    state = {
        anchorEl: null,
        open: false,
        editId: undefined,
        delDlgOpen: false,
        delId: undefined,
    };

    constructor() {
        super();
        this.handleDelete = this.handleDelete.bind(this);
        this.getRowId = row => row.customer_payment_id;
    }

    componentDidMount() {
        $("table[class*='Table-headTable']").addClass(this.props.classes.tableHeader);
    }

    handleDelete(id) {

        const data = this.props.data;
        this.props.deleteCustomerPayment({
            variables: { id: this.state.delId },
            refetchQueries: [
                {
                    query: queries.allCustomerPaymentsQuery,
                    variables: { customerId: this.props.customerId },
                },
            ],
        }).then(
            (resp) => {

                //data.refetch();
            }
        );
        this.setState({ delDlgOpen: false });
    }

    render() {

        if (this.props.quiet) {
            return (<LinearProgressEx loading={this.props.data.loading} />);
        }

        const columns = [

            { name: 'customer_id', title: getTxt('Customer') },
            { name: 'payment_type_cd', title: getTxt('Payment Type') },
            { name: 'payment_state_cd', title: getTxt('Payment State') },
            { name: 'payment_date', title: getTxt('Payment Date') },
            { name: 'payment_amount', title: getTxt('Payment Amount') },
            { name: 'payment_notes', title: getTxt('Payment notes') },
            { name: 'payment_account', title: getTxt('Payment Account') },
            { name: 'files', title: getTxt('Documents') },
            { name: 'customer_payment_id', title: getTxt('Actions') },
        ];

        createGridResizerCols(this.state, columns, {}, 180);

        const { classes } = this.props;

        let items = this.props.data.allCustomerPayments ? this.props.data.allCustomerPayments : [];
        const loading = this.props.data.loading;

        const caption = getTxt('Customer Payments');
        const subtitle = getTxt('List of customer payments.');

        const withSubtotal = [];

        if (items.length > 0) {
            let prevName;
            let total = 0;
            items.forEach((i) => {
                if (prevName && i.customer.display_name !== prevName) {
                    withSubtotal.push({
                        customer_payment_id: -1,
                        customer_id: -1,
                        payment_type_cd: '',
                        payment_state_cd: '',
                        payment_date: '',
                        payment_amount: total,
                        payment_notes: '',
                        payment_account: '',
                        customer: {
                            display_name: '',
                            customer_type_cd: '',
                        },
                    });
                    total = 0;
                }
                prevName = i.customer.display_name;
                const payment = Number.parseFloat(i.payment_amount);
                if (!isNaN(payment)) {
                    total += payment;
                }
                withSubtotal.push(i);
            });

            withSubtotal.push({
                customer_payment_id: -1,
                customer_id: -1,
                payment_type_cd: '',
                payment_state_cd: '',
                payment_date: '',
                payment_amount: total,
                payment_notes: '',
                payment_account: '',
                customer: {
                    display_name: '',
                    customer_type_cd: '',
                },
            });

            items = withSubtotal;
        }
        const this1 = this;
        return (

            <div className={classes.root}>
                <LinearProgressEx loading={loading} />

                {!this.props.noCaption && <RegularCard

                    className="mi-list-page-card"

                    headerClassName="mi-list-page-header"

                    className="mi-payments-list-card"
                    headerClassName="mi-payments-list-header"
                    headerColor="purple"
                    cardTitle={caption}
                    cardSubtitle={subtitle}
                    content={
                        <div>
                            {<Button
                                color="primary"
                                className={classes.button}
                                onClick={() => { this.setState({ editId: 'new' }); }}
                            >{getTxt('Add new Payment')}</Button>}
                        </div>

                    }
                />}

                {this.props.showAlterAddBtn &&
                    <Button
                        color="primary"
                        className={classes.button}
                        onClick={() => { this.setState({ editId: 'new' }); }}
                    >{getTxt('Add new Payment')}</Button>}

                <Grid

                    rows={items}
                    columns={columns}

                >

                    <CurrencyGridFormatter
                        for={['payment_amount']}
                    />

                    <FilteringState
                        defaultFilters={[{}]}
                    />

                    <SortingState
                        defaultSorting={[

                        ]}
                    />

                    <IntegratedFiltering
                        columnExtensions={[
                            { columnName: 'customer_id', predicate: filterByCustomer },
                            { columnName: 'payment_date', predicate: filterByPaymentDate },
                        ]}
                    />
                    <SortingState
                        defaultSorting={[]}
                    />
                    <IntegratedSorting
                        columnExtensions={[
                            // {
                            //     columnName: 'insurance_type_cd',
                            //     compare: (a, b) => {
                            //         const labelA = getLabel(DictionaryTypes.InsuranceType, a);
                            //         const labelB = getLabel(DictionaryTypes.InsuranceType, b);
                            //         if (labelA === labelB) {
                            //             return 0;
                            //         }
                            //         return (labelA < labelB) ? -1 : 1;
                            //     },
                            // },

                        ]}
                    />

                    <VirtualTable
                        messages={tableMessages}
                        columnExtensions={tableColumnExtensions}
                        rowComponent={({ row, ...restProps }) => {
                            if (row.customer_id === -1) {
                                return (<VirtualTable.Row
                                    className={classes.totalsRow}
                                    {...restProps}
                                />);
                            }
                            return (<VirtualTable.Row {...restProps} />);
                        }}
                        cellComponent={({ row, column, style, ...props }) => {

                            if (column.name === 'customer_id') {
                                return (<VirtualTable.Cell >
                                    <Link
                                        to={`/customers/${row.customer.customer_type_cd.toLowerCase()}/${row.customer_id}`} style={{ padding: '6px', color: '#9C27B0', fontWeight: 'bold' }} >
                                        {row.customer.display_name} </Link>
                                </VirtualTable.Cell>);
                            }
                            if (column.name === 'payment_type_cd') {
                                return (<VirtualTable.Cell>{getLabel(DictionaryTypes.PublicPaymentType, row.payment_type_cd)}</VirtualTable.Cell>);
                            }

                            if (column.name === 'payment_state_cd') {
                                return (<VirtualTable.Cell> {getLabel(DictionaryTypes.InsuranceItemPaymentState, row.payment_state_cd)} </VirtualTable.Cell>);
                            }

                            if (column.name === 'payment_date') {
                                return (<VirtualTable.Cell>
                                    {row.payment_date ? toItalianDateString(row.payment_date) : row.payment_date}
                                </VirtualTable.Cell>);
                            }

                            if (column.name === 'payment_account') {
                                return (<VirtualTable.Cell>
                                    {getLabel(DictionaryTypes.PaymentAccount, row.payment_account)}
                                </VirtualTable.Cell>);
                            }

                            if (column.name === 'customer_payment_id' && row.customer_id !== -1) {
                                return (<VirtualTable.Cell>

                                    <Tooltip title={getTxt('Edit')}>
                                        <IconButton size="small" onClick={() => { this.setState({ editId: row.customer_payment_id }); }} className={classes.inGridButton} >
                                            <Icon.Edit />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title={getTxt('Delete')}>
                                        <IconButton size="small" onClick={() => { this.setState({ delDlgOpen: true, delId: row.customer_payment_id }); }} className={classes.inGridButton} >
                                            <Icon.Delete />
                                        </IconButton>
                                    </Tooltip>

                                </VirtualTable.Cell>);
                            }
                            if (column.name === 'customer_payment_id' && row.customer_id === -1) {
                                return (<VirtualTable.Cell>{''}</VirtualTable.Cell>);
                            }
                            if (column.name === 'payment_amount') {
                                return (<VirtualTable.Cell>{toDecimalString(row.payment_amount)}</VirtualTable.Cell>);
                            }
                            if (column.name === 'files') {
                                if (row.customer_payment_id === -1) {
                                    return (<VirtualTable.Cell>{''}</VirtualTable.Cell>);
                                }
                                if (!row.files || (row.files && row.files.length === 0)) {
                                    return (<VirtualTable.Cell>
                                        <a
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                                this1.setState({ onlyFilesEditId: row.customer_payment_id });
                                            }} >{getTxt('no documents attached')}</a> </VirtualTable.Cell>);
                                }
                                if (row.files && row.files.length > 0) {
                                    return (<VirtualTable.Cell>
                                        <a
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                                this1.setState({ onlyFilesEditId: row.customer_payment_id });
                                            }} >{row.files.length + ' ' + getTxt('document(s) attached')}</a> </VirtualTable.Cell>);
                                }

                            }

                            return <VirtualTable.Cell {...props} />;
                        }}
                    />

                    <TableFilterRow
                        messages={filterRowMessages}
                        cellComponent={({ column, filter, onFilter, ...props }) => {
                            if (column.name === 'customer_payment_id') {
                                return (
                                    <TableFilterRow.Cell filteringEnabled >
                                        <span />
                                    </TableFilterRow.Cell>);
                            }
                            if (column.name === 'payment_type_cd') {
                                return (
                                    <c.gridColFilter noFilterVal={getTxt('Tutti')} setFilter={onFilter} >
                                        {getDictionary(DictionaryTypes.PublicPaymentType)}
                                    </c.gridColFilter>);
                            }
                            if (column.name === 'payment_state_cd') {
                                return (
                                    <c.gridColFilter noFilterVal={getTxt('Tutti')} setFilter={onFilter} >
                                        {getDictionary(DictionaryTypes.InsuranceItemPaymentState)}
                                    </c.gridColFilter>);
                            }
                            if (column.name === 'payment_account') {
                                return (
                                    <c.gridColFilter noFilterVal={getTxt('Tutti')} setFilter={onFilter} >
                                        {getDictionary(DictionaryTypes.PaymentAccount)}
                                    </c.gridColFilter>);
                            }
                            if (column.name === 'files') {
                                return (
                                    <TableFilterRow.Cell filteringEnabled >
                                        <span />
                                    </TableFilterRow.Cell>);
                            }


                            return <TableFilterRow.Cell onFilter={onFilter} filter={filter} {...props} />;
                        }}
                    />

                    <TableColumnResizing
                        columnWidths={this.state.columnWidths}
                        onColumnWidthsChange={(cols) => { this.setState({ columnWidths: cols }); }}
                        defaultColumnWidths={this.state.defColumnWidths}
                    />
                    <TableHeaderRow />

                </Grid>
                {
                    this.state.editId &&
                    <Customer_Payment_Edit
                        editId={this.state.editId}
                        realType={this.props.realType}
                        customerId={this.props.customerId}
                        AfterSubmit={((id) => {
                            this.setState({ editId: undefined });
                            if (id) {
                                this.setState({ paymentId: id, filesDlgOpen: true });
                            }
                            this.props.data.refetch();
                        })}

                    />
                }

                {
                    this.state.paymentId && this.state.filesDlgOpen &&
                    <Dialog onClose={() => { this.setState({ filesDlgOpen: false }); }} open={this.state.filesDlgOpen}>
                        <DialogTitle>{getTxt('Payment Documents.')}</DialogTitle>
                        <DialogContent>
                            <File_Search entityId={this.state.paymentId} />
                        </DialogContent>
                        <DialogActions>
                            <div className={classes.formButtons} >
                                <Button onClick={() => {
                                    this.setState({ filesDlgOpen: false, editId: this.state.paymentId });
                                }}
                                    className={classes.button}
                                    variant="contained">
                                    {getTxt('Back')}
                                </Button>
                                <Button onClick={() => this.setState({ filesDlgOpen: false })} className={classes.button} variant="contained" color="primary">
                                    {getTxt('Save')}
                                </Button>
                            </div>
                        </DialogActions>
                    </Dialog>
                }
                {
                    this.state.onlyFilesEditId &&
                    <Dialog onClose={() => { this.setState({ onlyFilesEditId: false }); }} open={this.state.onlyFilesEditId}>
                        <DialogTitle>{getTxt('Payment Documents.')}</DialogTitle>
                        <DialogContent>
                            <File_Search entityId={this.state.onlyFilesEditId} />
                        </DialogContent>
                        <DialogActions>
                            <div className={classes.formButtons} >
                                <Button onClick={() => {
                                    this.setState({ onlyFilesEditId: false });
                                }}
                                    className={classes.button}
                                    variant="contained">
                                    {getTxt('Cancel')}
                                </Button>
                                <Button onClick={() => this.setState({ onlyFilesEditId: false })} className={classes.button} variant="contained" color="primary">
                                    {getTxt('Save')}
                                </Button>
                            </div>
                        </DialogActions>
                    </Dialog>
                }


                <Dialog onClose={() => { this.setState({ delDlgOpen: false, delId: null }); }} open={this.state.delDlgOpen}>
                    <DialogTitle>{getTxt('Delete customer Payment.')}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <span> {getTxt('Customer payment will be delete on server.')} </span>
                            <br />
                            <span > {getTxt('Are you sure do you want delete the customer payment ?')} </span>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.handleDelete(this.state.delId)} color="primary">
                            {getTxt('Ok')}
                        </Button>
                        <Button onClick={() => { this.setState({ delDlgOpen: false, delId: null }); }} color="primary">
                            {getTxt('Annula')}
                        </Button>

                    </DialogActions>
                </Dialog>

            </div >
        );
    }


}

export default compose(

    graphql(queries.allCustomerPaymentsQuery, {

        options: props => (
            {
                variables:
                {
                    customerId: props.customerId,
                },
                fetchPolicy: 'network-only',
                errorPolicy: 'all',
            }),


    }),

    graphql(queries.deleteCustomerPaymentMutation, {
        name: 'deleteCustomerPayment',
        options: {
            errorPolicy: 'all',
        },
    }),

)(withStyles(styles)(Client_Payments_Search));

